import { useChannelTalk } from '@repo/channel-talk';
import { useUserEventLogger } from '@repo/tracking-service';
import { Button } from '@zenterprise-inc/ui';
import cn from 'clsx';
import Image from 'next/image';
import { useRouter } from 'next/router';

import { SurveyTopNavigation } from '@/components/survey/common/TopNavigation';
import common from '@/components/survey/common/ui/styles/common.module.scss';
import { SUPPORT_BOT_LINK } from '@/lib/constants/link';
import { COMMON_PATHS } from '@/lib/constants/paths';

export const SurveyExpiredContainer = () => {
  const router = useRouter();
  const { openChannelTalk } = useChannelTalk();
  const { sendClickEvent } = useUserEventLogger();

  return (
    <>
      <SurveyTopNavigation needConfirm={false} />
      <main className={cn(common.main_layout, common.main_cta_space, common.main_full_page_with_nav_layout)}>
        <article className={'my-auto'}>
          <section className={'-mt-[30px] flex flex-col items-center'}>
            <Image src={'/images/illus-icons/fill-t-warning-gy-rg.svg'} alt={'마감'} width={80} height={80} />
            <div className={'flex flex-col items-center gap-1 py-4 text-center'}>
              <h1 className={'headline-20 text-gray-900'}>제출 기한이 지났어요...</h1>
              <p className={'body-16 text-gray-700'}>
                고객센터로 설문 재발송을
                <br />
                문의해주시면 안내드릴게요.
              </p>
            </div>
          </section>
        </article>

        <Button.StickyBottom.Wrapper className={'px-4.5'}>
          <Button.StickyBottom.Button
            type={'button'}
            onClick={() => {
              router.push(COMMON_PATHS.환급조회목록);
              sendClickEvent('survey_expired_to-home');
            }}
          >
            홈으로
          </Button.StickyBottom.Button>
          <Button.StickyBottom.Button
            type={'button'}
            state={'primary'}
            onClick={() => {
              openChannelTalk(SUPPORT_BOT_LINK.home);
              sendClickEvent('survey_expired_cx-retry');
            }}
          >
            재발송 문의
          </Button.StickyBottom.Button>
        </Button.StickyBottom.Wrapper>
      </main>
    </>
  );
};
